import styled from "styled-components";

export const TimelineContainer = styled.div`
	width: 100%;
	height: 20px;
	flex-direction: row;
	position: relative;
`;

export const Element = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	justify-content: center;
	text-align: center;
	font-size: 10px;
	height: 20px;
	margin-top: 1px;
	font-size: 8px;
`;

export const Header = styled.div`
	display: flex;
	background-color: black;
	width: 100%;
	justify-content: center;
	align-items: center;
	height: 20px;
	margin-top: 1px;
	color: white;
`;
